const state = {
  token: localStorage.getItem('operator_access_token') || '',
  tokenScope: ''
}

const getters = {
  isAuthenticated: state => !!state.token,
  tokenScope: state => state.tokenScope
}

const mutations = {
  AUTH_SUCCESS (state, response) {
    const token = response.access_token
    state.token = token
    localStorage.setItem('operator_access_token', token)
  },
  SET_TOKEN_SCOPE (state, tokenScope) {
    state.tokenScope = tokenScope
  }
}

export default {
  state,
  getters,
  mutations
}
